import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core'
import {SortingOption, SortingOptions} from './sorting.types'
import {BehaviorSubject} from 'rxjs'
import {FilterOption, FilterOptions} from '../filter/filter.types'
import {FilterDropdownComponent} from '../filter/filter-dropdown/filter-dropdown.component'
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown'

@Component({
  selector: 'cft-sorting',
  templateUrl: './sorting.component.html',
  styles: `
    @reference "../../../styles/theme.css";
    :host {
      @apply block sm:relative;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SortingComponent implements OnInit {
  @Input()
  options!: SortingOptions

  @Output()
  protected readonly sortingChanged = new EventEmitter<SortingOption>()

  @ViewChild(FilterDropdownComponent)
  private dropdownRef!: FilterDropdownComponent

  protected defaultOption?: SortingOption
  protected readonly options$ = new BehaviorSubject<FilterOptions<string>>({
    isLoading: false,
  })
  protected readonly toggleIcon = faCaretDown

  ngOnInit(): void {
    this.defaultOption = this.options.find(option => option.default)
    this.options$.next({
      isLoading: false,
      options: this.options,
    })
  }

  show(): void {
    this.dropdownRef.show(true)
  }

  selected(option: FilterOption<unknown>): void {
    if (typeof option.value === 'string') {
      this.defaultOption = option as SortingOption
      this.sortingChanged.emit(option as SortingOption)
    }
  }
}
